import React, { useEffect, useState } from 'react';

export default function EnvironmentStatsStatus({ stats, error = false, loading = false }) {
  const [now, setNow] = useState(Date.now);
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), 10000);
    return () => clearInterval(timer);
  }, []);
  const time = stats?.observedAt && new Date(stats.observedAt);
  const validTime = time && Number.isFinite(time.getTime());
  const stale = error || stats?.available === false || (validTime && now - time.getTime() > 60000);
  const observed = validTime ? `Last observed ${time.toLocaleTimeString()}` : '';
  return <p role="status" style={{ fontSize: 11, marginTop: 8, color: stale ? 'var(--accent-warning)' : 'var(--text-muted)' }}>
    {loading && !stats ? 'Loading environment counts…'
      : stale || !stats ? `Live counts unavailable. ${observed || 'Counts are shown as — until an inventory succeeds.'}`
        : observed}
  </p>;
}

export function AdditionalEnvironmentStates({ stats, prefix = '' }) {
  const labels = { creating: 'starting', stopping: 'stopping', error: 'error', unknown: 'unknown' };
  const parts = Object.entries(labels).filter(([key]) => stats?.[key] > 0).map(([key, label]) => `${stats[key]} ${label}`);
  return parts.length ? <span style={{ fontSize: 12, color: 'var(--accent-warning)' }}>{prefix}{parts.join(' · ')}</span> : null;
}
